import { render, staticRenderFns } from "./HistoryOfChangesPopup.vue?vue&type=template&id=cbd4a9f4"
import script from "./HistoryOfChangesPopup.vue?vue&type=script&lang=js"
export * from "./HistoryOfChangesPopup.vue?vue&type=script&lang=js"
import style0 from "./HistoryOfChangesPopup.vue?vue&type=style&index=0&id=cbd4a9f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports